<template>
    <div class="form__row form__row--border">
        <div class="upload-photo">
            <div class="upload-photo__empty-container">
                <div class="btn btn--round" @click="requestRemove">
                    <i class="icon-cross"></i>
                </div>
                <img v-bind:src="photoSrc"/>
                <div class="upload-photo__empty" v-show="uploading" v-cloak>
                    <div class="upload-photo__empty-content">
                        <div class="spinner"></div>
                        <div class="loading-status">{{uploadProgressMsg}}</div>
                    </div>
                </div>
                <div class="upload-photo__empty" v-show="confirmRemove" v-cloak @click="cancelRemove">
                    <div class="upload-photo__empty-content">
                        <h4>{{messages.questionnaire_photo_remove_heading}}</h4>
                        <p>{{messages.questionnaire_photo_remove_instruction}}</p>
                        <input type="button" @click.stop="remove"
                               :value="messages.questionnaire_photo_remove_confirm_btn"
                               class="btn btn--subtle btn--error">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Mixins} from '@bvm/core'
    import {QuestionnaireApi as api} from '../../api'

    export default {
        mixins: [Mixins.Lang],
        props: {
            id: {type: Number}, // ID of a stored image
            base64: {type: String}, // Base64 encoded string containing the image data
            uploading: {type: Boolean, default: false},
            uploadProgress: {type: Number}
        },
        data() {
            return {
                messageKeys: [
                    'questionnaire_photo_upload_progress',
                    'questionnaire_photo_remove_heading',
                    'questionnaire_photo_remove_instruction',
                    'questionnaire_photo_remove_confirm_btn'
                ],
                messages: {},
                confirmRemove: false
            };
        },
        computed: {
            photoSrc() {
                return this.base64 || api.photoEndpoint(this.id);
            },
            uploadProgressMsg() {
                return this.messages.questionnaire_photo_upload_progress ? this.messages.questionnaire_photo_upload_progress.replace("%d", this.uploadProgress) : '';
            }
        },
        methods: {
            requestRemove() {
                this.confirmRemove = true;
            },
            cancelRemove() {
                this.confirmRemove = false;
            },
            remove() {
                this.$emit('removed', this.id);
            }
        }
    }
</script>
